<div class="main-container" (click)="stopPropagation($event)">
  <div class="close-btn" (click)="close($event)">
    <img src="assets/comment_close.svg" />
  </div>
  <div class="add-comment"> 
    <div class="label" *ngIf="!readonly || (readonly && shouldEnableOnlyCommentsFeature)">{{ 'COMMENT_POPUP.ADD_COMMENT' | translate }}</div>
    <div class="label" *ngIf="readonly && !shouldEnableOnlyCommentsFeature">{{ 'COMMENT_POPUP.COMMENTS' | translate }}</div>
    <textarea     
      *ngIf="!readonly || (readonly && shouldEnableOnlyCommentsFeature)"
      tabindex="0"
      rows="2"
      class="text"
      value="{{ currentComment }}"
      (keydown.enter)="stopPropagation($event)"
      (keyup)="onTypeComment($event)"
      autofocus
      focusSelect
    ></textarea>
  </div>
  <div class="comments-wrapper">
    <div
      class="comment-row"
      *ngFor="let comment of comments"
      id="{{ 'comment-row-' + comment._id }}"
    >
      <div class="comment-text">
        {{ comment.text }}
      </div>
      <input
        id="{{ 'edit' + comment._id }}"
        class="comment-text"
        value="{{ comment.text }}"
        *ngIf="editCommentId === comment._id && !readonly"
        (keydown.enter)="stopPropagation($event)"
        (keyup)="onEditComment($event, comment)"
        autofocus
        focusSelect
      />
      <div class="kebab-menu" [offset]="{x: 0, y: -30}" [position]="'left'" [opsActionMenu]="'action-menu-' + comment._id" [optionsFactory]="getOptions.bind(this)" (itemSelected)="onSelectAction($event, comment._id)">
        <img src="assets/kebab-menu-purple.svg" />
      </div>  
      <ops-action-menu
      [menuId]="'action-menu-' + comment._id"
      [options]="getOptions()"
      (itemSelected)="onSelectAction($event, comment._id)"
    ></ops-action-menu>
      <!-- <ops-dropdown
        id="{{ 'action-menu-' + comment._id }}"
        [options]="getOptions()"
        [isMultiSelect]="false"
        [startingFocusIndex]="0"
        (valueSelected)="onSelectAction($event, comment._id)"
        class="action-menu"
      >
      </ops-dropdown> -->
    </div>
  </div>
</div>
<div #modalbackground class="background" (click)="close($event)"></div>
